<template>
    <div class="target-build-failed-tests">
        <b-button @click="onDownloadFailedTestCasesClick" type="is-primary" expanded icon-left="download">
            Download failed test cases file
        </b-button>

        <b-table
            :data="failedTestCases"
            ref="table"
            paginated
            per-page="50"
            :opened-detailed="defaultOpenedDetails"
            detailed
            detail-key="id"
            @details-open="onDetailsOpen($event.id)"
            @click="$refs.table.toggleDetails($event)"
            show-detail-icon
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">

            <b-table-column field="test" label="Test case" sortable v-slot="props">
                {{ props.row.test }}
            </b-table-column>

            <template #detail="props">
                <FailedTestLogsDetails :loading="loadingTestCases.includes(props.row.id)"
                                       style="max-width: 90vw"
                                       :test-results="failedTestResultsLogsDetails[props.row.id.toString()]"/>
            </template>

        </b-table>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { downloadFile } from "@/utils/helpers";
import FailedTestLogsDetails from "@/components/FailedTestLogsDetails";

export default {
    name: "TargetBuildFailedTests",
    props: {
        failedTestCases: Array,
        targetBuild: Object,
    },
    components: {
        FailedTestLogsDetails,
    },
    data() {
        return {
            defaultOpenedDetails: [],
            loadingTestCases: [],
        }
    },
    computed: {
        ...mapGetters('TargetBuilds', [
            'failedTestResultsLogsDetails',
        ]),
    },
    methods: {
        ...mapActions('TargetBuilds', [
            'fetchFailedTestResultsByTestCase',
        ]),
        onDownloadFailedTestCasesClick() {
            downloadFile(`${this.targetBuild.target}-failed-test-cases.txt`,
                this.failedTestCases.map(item => item.test).join("\n"));
        },
        async onDetailsOpen(testCaseId) {
            if (this.failedTestResultsLogsDetails[testCaseId.toString()]) return;
            this.loadingTestCases.push(testCaseId);
            await this.fetchFailedTestResultsByTestCase({
                targetBuildId: this.targetBuild.id,
                testCaseId
            });
            this.loadingTestCases.splice(this.loadingTestCases.indexOf(testCaseId), 1);
        }
    }
}
</script>

<style scoped>

</style>